import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { KeyRound } from "lucide-react";

const inp = "w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-vino-500 focus:ring-2 focus:ring-vino-500/20";

// Obligatorio para quienes aún usan su correo (o una clave asignada) como contraseña.
export function OfertaPassword() {
  const { user, setUser, logout } = useAuth();
  const [f, setF] = useState({ actual: "", nueva: "", confirmar: "" });
  const [busy, setBusy] = useState(false);
  if (!user?.password_predeterminada) return null;
  const enviar = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await api.post("/perfil/password", f);
      if (r.data.token) localStorage.setItem("roge_token", r.data.token);
      toast.success("¡Listo! Tu contraseña se cambió correctamente");
      setUser({ ...user, password_predeterminada: false });
      window.location.reload();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-vino-900/80 p-4 backdrop-blur-sm" data-testid="cambio-password-obligatorio">
      <form onSubmit={enviar} className="w-full max-w-md space-y-3 rounded-2xl bg-white p-6 shadow-2xl">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-vino-50 text-vino-700"><KeyRound className="h-5 w-5" /></span>
          <div>
            <p className="font-display text-lg font-semibold text-slate-900">Crea tu contraseña personal</p>
            <p className="text-xs text-slate-500">Por tu seguridad, debes cambiarla antes de ver tu información.</p>
          </div>
        </div>
        <input type="password" required placeholder="Contraseña actual" value={f.actual} onChange={(e) => setF({ ...f, actual: e.target.value })} className={inp} data-testid="obligatorio-actual" />
        <input type="password" required placeholder="Nueva contraseña (8+, mayúscula, minúscula y número)" value={f.nueva} onChange={(e) => setF({ ...f, nueva: e.target.value })} className={inp} data-testid="obligatorio-nueva" />
        <input type="password" required placeholder="Confirmar nueva contraseña" value={f.confirmar} onChange={(e) => setF({ ...f, confirmar: e.target.value })} className={inp} data-testid="obligatorio-confirmar" />
        <button disabled={busy} className="w-full rounded-lg bg-vino-700 py-2.5 text-sm font-semibold text-white hover:bg-vino-800 disabled:opacity-60" data-testid="obligatorio-guardar">Guardar y continuar</button>
        <button type="button" onClick={logout} className="w-full text-xs text-slate-500" data-testid="obligatorio-salir">Cerrar sesión</button>
      </form>
    </div>
  );
}
